const CardHeader = ({ code, title, version, ...props }) => {
  return (
    <header className="card__header" {...props}>
      <h2>
        <span>{code}</span> - {title}
      </h2>
      <h3>{version}</h3>
    </header>
  );
};

export default CardHeader;
